import moment from "moment";

/**
 * Formats a date into a human-readable value.
 * @param {string} val - The date to be formatted.
 * @param {boolean} showSeconds - Whether to show seconds or not. Defaults to false.
 * @returns {string} The formatted date and time (hours and minutes).
 * @example datetime('2021-06-03T12:19:06.000000Z') // => '3 jun 2021 14:19'
 * @example datetime('2021-06-03T12:19:06.000000Z', true) // => '3 jun 2021 14:19:06'
 */
export const datetime = (val, showSeconds = false) =>
{
    if (val === undefined || val === null || val === '') return '';
    else return new Date(val).toLocaleString('nl-NL', {
      'day': 'numeric',
      'month': 'short',
      'year': 'numeric',
      'hour': 'numeric',
      'minute': 'numeric',
      'second': showSeconds ? 'numeric' : undefined,
  });
}

/**
 * Formats a date into a human-readable value.
 * @param {string} val - The date to be formatted.
 * @returns {string} The formatted date.
 * @example date('2021-06-03T12:19:06.000000Z') // => '3 juni 2021'
 */
export const date = (val) =>
{
    if (val === undefined || val === null || val === '') return '';
    else return new Date(val).toLocaleString('nl-NL', {
        'day': 'numeric',
        'month': 'short',
        'year': 'numeric',
    });
};

/**
 * Gets today's date.
 * @returns {string} The formatted date.
 * @example today() // => '2021-06-03'
 */
export const today = () => moment().format('YYYY-MM-DD');

/**
 * Gets the date of the next day.
 * @returns {string} The formatted date.
 * @example tomorrow() // => '2021-06-04'
 */
export const tomorrow = () => moment().add(1, 'day').format('YYYY-MM-DD')

/**
 * Converts a date into a human-readable value, relative to today.
 * @param {string} date - The date to be formatted.
 * @param {string} locale - The locale to be used. Defaults to 'nl-NL'.
 * @returns {string} The formatted date.
 * @example relativeDate('2021-06-03T12:19:06.000000Z') // => '2 dagen geleden'
 */
export const humanDate = (date, locale = 'nl-NL') => moment(date).locale(locale).fromNow();

export default { datetime, date, today, tomorrow, humanDate };